import { useRefreshOnPortalMessage } from './useRefreshOnPortalMessage';

/**
 * Runs `refresh` when the AcombaGO host reports that Transphere payments were just applied in its
 * collection window. Applying happens in another AcombaGO window, so without this signal the
 * unapplied-payments banner would keep showing an amount the user just collected.
 *
 * The host posts it whenever a save run applied at least one payment — including a run stopped early
 * by a blocking error, since the payments saved before the error moved the total too.
 */
export const useRefreshOnTranspherePaymentsApplied = (refresh: () => void): void => {
    useRefreshOnPortalMessage('portal:transphere-payments-applied', refresh);
};
